export enum FilterParamsEnum {
  MinDate = 'minDate',
  MaxDate = 'maxDate',
  MinTotalAmount = 'minTotalAmount',
  MaxTotalAmount = 'maxTotalAmount',
  MinTotalAmountPaid = 'minTotalAmountPaid',
  MaxTotalAmountPaid = 'maxTotalAmountPaid',
  Statuses = 'statuses',
}
